import { leadingZero } from "../../cpcoc/leadingZero";
import { months } from "../../cpcoc/months";
export function formatRefreshDateTime(dateValue) {
    let string = "";
    if (dateValue) {
        const today = new Date();
        const refreshDate = new Date(dateValue);
        const minutes = leadingZero(refreshDate.getMinutes());
        let hours = refreshDate.getHours();
        let period = "AM";
        if (refreshDate.toDateString() !== today.toDateString()) {
            const year = refreshDate.getFullYear();
            const month = refreshDate.getMonth();
            const date = refreshDate.getDate();
            string += `${months[month]} ${date}`;
            if (year !== today.getFullYear()) {
                string += ` ${year}`;
            }
            string += "<br />";
        }
        if (hours > 12) {
            hours = hours - 12;
            period = "PM";
        }
        else if (hours === 0) {
            hours = 12;
        }
        string += `${hours}:${minutes} ${period}`;
    }
    return string;
}
